import React, { useEffect, useRef } from "react";

import styled from "styled-components/macro";

import { isValidMonthDay } from "Utilities/Date/isValidMonthDay";

import { useFnrDateInput2 } from "./FnrDatePicker2Context";

export default function YearInput({ focusColor, disabled }) {
  const { state, setYear, setDay } = useFnrDateInput2();
  const { year, month, day, activeField } = state;
  const inputRef = useRef();

  function handleChange(e) {
    const { value } = e.target;
    const justDigits = value.replace(/\D/g, "");
    if (justDigits.length > 4) return;

    setYear(justDigits);
    if (justDigits.length === 4) clearDayIfInvalid(justDigits);
  }

  function clearDayIfInvalid(year) {
    // this is only relevant if changing the year to a non-leap year after selecting Feb 29.
    const isValid = isValidMonthDay({ month, day, year });
    if (!isValid && day) setDay(null);
  }

  useEffect(() => {
    if (activeField === "year") {
      inputRef.current.focus();
    }
  }, [activeField]);

  return (
    <YearField
      data-cy="fnrYearField"
      ref={inputRef}
      value={year}
      onChange={handleChange}
      type="text"
      placeholder="Year"
      focusColor={focusColor}
      pattern="\d{4}"
      autoFocus={false}
      disabled={disabled}
    />
  );
}

const YearField = styled.input`
  padding: 0px 10px;
  margin: 3px 12px;
  border-radius: 10px;
  border: none;
  background: none;
  appearance: none;
  color: #333;
  font-size: inherit;
  font-weight: 400;
  outline: none;
  max-width: 70px;
  font-family: inherit;
  font-weight: inherit;
  height: 32px;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }

  &::placeholder {
    color: #333;
    opacity: 0.7;
  }

  &:focus {
    outline: ${(props) =>
      props.focusColor
        ? `2px solid ${props.focusColor}b5`
        : `2px solid #248cc0b5`};
  }
`;
